import { Component, OnInit, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { IvFormComponent } from '../../../shared/components/iv-form/iv-form.component';
import { OperationService } from '../../../api';
import { CustomFields } from '../../../api/model/customFields';
import { TranslateService } from '../../../core/translation';
import { FormConfig } from '../../../shared/types/legacy';


@Component({
  selector: 'app-custom-inputs',
  templateUrl: './custom-inputs.component.html',
  styleUrls: ['./custom-inputs.component.scss'],
  providers: [OperationService]
})

export class CustomInputsComponent implements OnInit, AfterViewInit {



  /**
   * IvForm component from platform.
   */
  @ViewChild('ivform') ivform: IvFormComponent;

  /**
   * Event triggered when finish the signature.
   */
  @Output() submit = new EventEmitter<any>();

  /**
   * Event triggered when there's an error.
   */
  @Output() onError = new EventEmitter();

  /**
   * Object containing the form distribution.
   */
  customInputsForm: FormConfig = {};

  /**
   * Boolean that controls if there's a signature.
   */
  signature: boolean = false;

    /**
   * Field type
   */
  fieldType: string = '';

  /**
   * Object containing error labels.
   */
  errorMessages: object = {
    'required': this._translate.instant('form_error_required'),
    'nif': this._translate.instant('form_error_nif')
  };

  /**
   * String that contains operation id.
   */
  operationId: string = null;

  /**
   * Object containing data of the operation.
   */
  customFields: CustomFields[] = null;

  constructor(
    private _translate: TranslateService
  ) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    if (this.signature) {
    }
  }

  /**
   * Function that control if there's a signature.
   * @param {boolean} value Boolean that contains if there's a signature.
   */
  setSignature(value: boolean) {
    this.signature = value;
  }

  /**
   * Function that sets data of the operation.
   * @param {any} data Object that contains data .
   */
  setData(data: any) {
    this.operationId = data.id;
    this.customFields = data.formData;


    this.customFields.sort(function (a, b) {
      return a.order - b.order;
    });

    for (const field of this.customFields) {
      this.customInputsForm[field.key] = { type: field.type, label: '', _label: field.label, validators: [], customHtml: false };
      this.fieldType = field.type;
      if (field.customHTML) {
        this.customInputsForm[field.key].customHtml = true;
      }
      if (field.required && field.type != 'date') {
        this.customInputsForm[field.key].validators = ['required', field.regex];
      } else if(field.required && field.type == 'date') {
        this.customInputsForm[field.key].validators = ['required'];
      }
      else {
        this.customInputsForm[field.key].validators = [field.regex];
      }
    }

    for (const key in this.customInputsForm) {
      if (this.customInputsForm[key]._label && this.customInputsForm[key].validators.includes('required')) {
        this.customInputsForm[key].label = this._translate.instant(this.customInputsForm[key]._label + ' *');
      } else if (this.customInputsForm[key]._label) {
        this.customInputsForm[key].label = this._translate.instant(this.customInputsForm[key]._label);
      }
    }
  }

  clear() {
    this.ivform.Form.reset();
  }

  /**
   * Function that controls signing pdf.
   * @param {Function} callback Function triggered when finish the server petition.
   */
  fillForm() {
    if (!this.ivform?.Form.valid && this.fieldType != 'date') {
      this.emitError(null);
      this.ivform.Form.markAllAsTouched();
      this.ivform.Form.updateValueAndValidity();

      return;
    }
    if (this.signature) {
      this.emitError(this._translate.instant('otpsigner_error_no_signature'));

      return;
    }
    const metadata = [];
    const keys = Object.keys(this.ivform.Form.value);
    for (const key of keys) {
      if (this.ivform.Form.get(key)) {
        metadata.push({ 'key': key, 'value': this.ivform.Form.get(key).value });
      } else if(this.ivform.Form.get(key) && this.customInputsForm[key].type == 'date'){
        metadata.push({ 'key': key, 'value': this.customInputsForm[key].value.toString() });
      }
    }

    return metadata;
  }


  /**
   * Function triggered wuen there's an error.
   * @param {any} error Object that contains the form configuration.
   */
  emitError(error: any) {
    this.onError.emit(error);
  }
}
